











































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { Page } from "@/api/types";
@Component({
  name: "AgroTablePagination",
  components: {
    AgroIcons
  },

})
export default class AgroTablePagination extends Vue {
  @Prop({ type: Number, default: 0 }) private readonly totalPages!: number;
  @Prop({ type: Number, default: 0 }) private readonly totalElements!: number;
  @Prop({ type: Number, default: 10 }) private readonly pageSize!: number;
  
  private currentPage: number = 0;
  private internalPageSize: number = this.pageSize;
  private firsts: number = 3;
  private lasts: number = 0;

  @Emit("paginate")
  private paginate(page: Page, immediate: boolean = true) {}

  @Watch("internalPageSize", { immediate: true })
  private onPageSizeChanged() {
    this.doPaginate(false)
  }

  @Watch("currentPage", { immediate: true })
  private onPageChange() {
    this.doPaginate()
  }

  
  private doPaginate(immediate: boolean = true) {
    const size = this.internalPageSize > 0 ? this.internalPageSize : this.pageSize;
    this.currentPage = this.currentPage * size > this.totalElements ? 0 : this.currentPage;
    this.paginate(new Page(this.currentPage, size), immediate);
  }

  private updated() {
    if(this.totalPages && this.totalPages > 20) {
      this.firsts = 3;
    }
  }

} 
